import {
  faBuilding,
  faPerson,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import ContactCard from "../ContactCard";
import CustomModal from "../../../../layout/CustomModal";
import TabContent from "../../../../layout/Tabs/TabContent";
import TabHeader from "../../../../layout/Tabs/TabHeader";
import TabBody from "../../../../layout/Tabs/TabBody";
import TabLink from "../../../../layout/Tabs/TabLink";
import crudApi from "@serie3/common/api/crudApi";
import CrmConfig from "@serie3/freelancesplaceapi/Config/Crm/CrmConfig";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { btn, btnHoverStyle } from "../../../../layout/Buttons/buttonStyles";

const CustomerModal = ({ show, setShow, updateContact }) => {
  const [allCompanies, setAllCompanies] = useState([]);
  const [allPeople, setAllPeople] = useState([]);

  const prefix = "finance-customer-picker";

  const CardButtons = ({contact}) => {
    return (
      <>
        <style>{btnHoverStyle}</style>
        <button
          className="btn-modern"
          style={{ ...btn.base, ...btn.icon, ...btn.iconSoft("#e8f0fe", "#1a73e8") }}
          onClick={() => {
            updateContact(contact);
            setShow(0);
          }}
        >
          <FontAwesomeIcon icon={faPlus} />
        </button>
      </>
    );
  };

  const loadDataFunction = (type) => {
    switch (type) {
      case "companies":
        crudApi.getAll(
          CrmConfig.company.index.endpoint,
          setAllCompanies,
          CrmConfig.company.index.datafield
        );
        break;
      case "people":
        crudApi.getAll(
          CrmConfig.people.index.endpoint,
          setAllPeople,
          CrmConfig.people.index.datafield
        );
        break;
    }
  };

  return (
    <CustomModal setShow={setShow} show={show} title={"Choose Customer"}>
      <TabHeader style={{ width: "100%" }} bold>
        <TabLink
          prefix={prefix}
          name={"Companies"}
          icon={faBuilding}
          ignoreWith={true}
          style={{ minWidth: "50%" }}
          bold
          onClick={() => loadDataFunction("companies")}
        />
        <TabLink
          prefix={prefix}
          name={"People"}
          icon={faPerson}
          ignoreWith={true}
          style={{ minWidth: "50%" }}
          bold
          onClick={() => loadDataFunction("people")}
        />
      </TabHeader>

      <TabBody>
        <TabContent prefix={prefix} name={"Companies"}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: "12px" }}>
            {allCompanies && allCompanies.length > 0
              ? allCompanies.map((company, index) => (
                  <ContactCard
                    key={index}
                    contact={company}
                    CardButtons={() => <CardButtons contact={company} />}
                  />
                ))
              : <div style={{ color: "#9e9e9e", fontSize: "0.9rem" }}>Click the tab to load companies.</div>}
          </div>
        </TabContent>
        <TabContent prefix={prefix} name={"People"}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: "12px" }}>
            {allPeople && allPeople.length > 0
              ? allPeople.map((person, index) => (
                  <ContactCard
                    key={index}
                    contact={person}
                    CardButtons={() => <CardButtons contact={person} />}
                  />
                ))
              : <div style={{ color: "#9e9e9e", fontSize: "0.9rem" }}>Click the tab to load people.</div>}
          </div>
        </TabContent>
      </TabBody>
    </CustomModal>
  );
};

export default CustomerModal;
